import UserCard from "../page_components/user/user_card";
import UserTable from "../page_components/user/user_table";

const Users = () => {
    return (<>
        <div className="container-xxl flex-grow-1 container-p-y">
            <h4 className="py-3 mb-4"><span className="text-muted fw-light">Users</span></h4>
            <UserCard/>
            <UserTable/>
        </div>
    </>);
}

export default Users;